export default __webpack_public_path__ + "static/036-soft-skills-70759db0d03d287129f8a7793c725113.svg";